module.exports = __webpack_public_path__ + "static/img/brees-2013-top.8abab48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2013-top.jpg
// module id = UKwl
// module chunks = 1